import React from "react";
import { motion } from "framer-motion";
import "./SorryMessage.scss";

const SorryMessage = () => {
  return (
    <motion.div
      whileInView={{ scale: [0, 1] }}
      transition={{ duration: 0.25 }}
      className="sorryPage"
    >
      <p>Sorry for inconvenience</p>
      <p>There is an issue with data fetching from the server.</p>
      <p>Please Make sure you are connected to the internet Or</p>
      <p>You can refresh the page to reconnect to the server again.</p>
    </motion.div>
  );
};

export default SorryMessage;
